import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IOutlineService = ( createDecorator('IOutlineService'));
export { IOutlineService };
